import translating from './translate.json';

const fields = () => {
  return [
    {
      name: 'name',
      label: translating.name,
      required: true
    },
    {
      name: 'minB1Value',
      label: translating.minB1,
      type: 'number',
      required: true,
      width: '100px'
    },
    {
      name: 'maxB1Value',
      label: translating.maxB1,
      type: 'number',
      required: true,
      width: '100px'
    },
    {
      name: 'minB2Value',
      label: translating.minB2,
      type: 'number',
      required: true,
      width: '100px'
    },
    {
      name: 'maxB2Value',
      label: translating.maxB2,
      type: 'number',
      required: true,
      width: '100px'
    },
    {
      name: 'minB3Value',
      label: translating.minB3,
      type: 'number',
      required: true,
      width: '100px'
    },
    {
      name: 'maxB3Value',
      label: translating.maxB3,
      type: 'number',
      required: true,
      width: '100px'
    }
  ];
};

export default fields;
